import { GallerImageModal } from "./utils"
import React, { useCallback, useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { GalleryIcon } from "components/page-components/Icons/medium"
import { useSwipeable } from "react-swipeable"

export const Gallery = ({ images, defaultImage }) => {
  const [modal_active, set_modal_active] = useState(false)
  const [selected_image, set_selected_image] = useState(-1)

  const open_gallery_modal = (e) => {
    e.preventDefault()
    set_modal_active(true)
    set_selected_image(0)
  }

  const close_gallery_modal = () => {
    set_modal_active(false)
    set_selected_image(-1)
  }

  const go_back = useCallback(() => {
    if (selected_image > 0) {
      set_selected_image(selected_image - 1)
    } else {
      set_selected_image(images.length - 1)
    }
  }, [selected_image, images.length])

  const go_forward = useCallback(() => {
    if (selected_image < images.length - 1) {
      set_selected_image(selected_image + 1)
    } else {
      set_selected_image(0)
    }
  }, [selected_image, images.length])

  const handle_user_key_press = useCallback(
    (e) => {
      const { keyCode } = e
      if (modal_active) {
        switch (keyCode) {
          case 37:
            go_back()
            break
          case 39:
            go_forward()
            break
          default:
            close_gallery_modal()
        }
      }
    },
    [go_back, go_forward, modal_active]
  )

  useEffect(() => {
    window.addEventListener("scroll", close_gallery_modal)
    window.addEventListener("keydown", handle_user_key_press)
    return () => {
      window.removeEventListener("scroll", close_gallery_modal)
      window.removeEventListener("keydown", handle_user_key_press)
    }
  }, [handle_user_key_press])

  images = images.map((image) => (image.childImageSharp ? image : defaultImage))
  !images.length && images.push(defaultImage)

  const swipe_handlers = useSwipeable({
    onSwipedLeft: go_forward,
    onSwipedRight: go_back,
    onSwipedUp: close_gallery_modal,
    onSwipedDown: close_gallery_modal,
    preventDefaultTouchmoveEvent: true,
  })

  return (
    <React.Fragment>
      <div {...swipe_handlers}>
        <div
          onClick={open_gallery_modal}
          aria-label="Zoomable Image"
          role="button"
          tabIndex="-1"
          onKeyDown={open_gallery_modal}
          className="zoom-img-wrapper"
          style={{ position: "relative" }}
        >
          <GatsbyImage
            image={images?.[0]?.childImageSharp?.gatsbyImageData}
            alt={images?.[0]?.fields?.caption}
            title={images?.[0]?.fields?.caption}
            style={{ cursor: "zoom-in", maxHeight: 350 }}
            objectPosition={
              !!images?.[0]?.fields?.focus_point?.x
                ? `${Math.round(
                    100 * images?.[0]?.fields?.focus_point?.x
                  )}% ${Math.round(100 * images?.[0]?.fields?.focus_point?.y)}%`
                : undefined
            }
          />
          <div className="zoom-img-overlay"></div>
          <div
            style={{
              position: "absolute",
              right: 20,
              top: 20,
            }}
          >
            <GalleryIcon {...{ size: 0.8 }} />
          </div>
          <div
            className="tag is-rounded has-text-weight-bold has-text-mitternachtsblau"
            style={{
              position: "absolute",
              left: 20,
              bottom: 20,
            }}
          >
            + {images.length - 1} Bild{images.length - 1 > 1 ? "er" : ""}
          </div>
        </div>

        {images.map((image, index) => (
          <GallerImageModal
            key={`galleryimage-modal-${index}`}
            {...{
              selected_image,
              index,
              close_gallery_modal,
              image,
              go_back,
              go_forward,
            }}
          />
        ))}
      </div>
    </React.Fragment>
  )
}
